import Vue from 'vue'
import Vuex from 'vuex';
import VueRouter from 'vue-router';

Vue.use(Vuex);
Vue.use(VueRouter)

const store = new Vuex.Store({});

import VueJsSIP from '@voicenter-team/vsip';

import App from './App.vue'

Vue.use(VueJsSIP, {
    store
});

Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
    store
}).$mount('#app');
